module.exports = __webpack_public_path__ + "static/MykytaDidenko-62c6d9d4d5c78d466ae6fe2ab2310b04.jpeg";